var API_DOMAIN  = "https://ksrcrackers.com/api";

export default API_DOMAIN